'use client'

import type { PropsWithChildren } from 'react'
import { getTestProps } from '../../../utils/testing.ts'
import { usePageHeaderContext } from './use-page-header.ts'

export const PageHeaderMain = ({ children }: PropsWithChildren) => {
  const { dataTestId, dataTrackingId } = usePageHeaderContext()
  return (
    <div className="flex grow flex-col justify-start">
      <div
        {...getTestProps({
          dataTestId: `${dataTestId}-main`,
          dataTrackingId: `${dataTrackingId}-main`,
        })}
        className="flex flex-col items-start justify-start"
      >
        {children}
      </div>
    </div>
  )
}
